(function ($) {
    $(function () {
        $('.service-faqs').each(function (i, el) {
            var $faqs = $(el).find('.faq');
            $faqs.find('.faq-answer').slideUp(0);
            $faqs.find('.faq-trigger').on('click', function (e) {
                var $faq = $(e.target).closest('.faq');
                if ($faq.hasClass('active')) {
                    $faq.removeClass('active');
                    $faq.find('.faq-answer').slideUp(300);
                }
                else {
                    $('.faq.active').find('.faq-answer').slideUp(300);
                    $('.faq.active').removeClass('active');
                    $faq.addClass('active');
                    $faq.find('.faq-answer').slideDown(300);
                }
            });
        });
    });
})(jQuery);
